/**
 * Après cart/change ou re-fetch des sections, le Liquid peut être rendu sans le même
 * contexte localization → le HTML repasse en TTC + HT. Ce module réapplique l’affichage
 * « prix catalogue + libellé HT » à partir du JSON panier (source de vérité) si la page
 * a été chargée en mode shopify_ht_only (theme.shopify_ht_only).
 */
(function () {
  function getCartJsonUrl() {
    if (typeof theme === 'undefined' || !theme.routes) return '/cart.js';
    var root = theme.routes.root_url || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'cart.js';
  }

  function moneyCents(cents) {
    if (typeof formatMoney !== 'function' || typeof theme === 'undefined') return '';
    var fmt;
    if (theme.settings && theme.settings.currency_code_enabled) {
      fmt =
        theme.settings.money_with_currency_format_actual ||
        theme.settings.money_with_currency_format;
    } else {
      fmt = theme.settings.money_format || theme.settings.money_with_currency_format;
    }
    return formatMoney(cents, fmt || '${{amount}}');
  }

  function escapeAttr(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  window.getShopifyThemeCartJsonUrl = getCartJsonUrl;

  window.applyShopifyHtOnlyCartFromState = function (cartState) {
    if (!cartState || !cartState.items || typeof theme === 'undefined' || !theme.shopify_ht_only) {
      return;
    }

    var label = (theme.strings && theme.strings.price_without_taxes) || '';

    cartState.items.forEach(function (item, idx) {
      var n = idx + 1;
      var rows = [
        document.querySelector('#Cart-Drawer #CartDrawerItem-' + n),
        document.querySelector('#Cart #CartItem-' + n)
      ];

      rows.forEach(function (row) {
        if (!row) return;
        var priceRoot = row.querySelector('.product-cart-item-price .price');
        if (!priceRoot) return;

        var unitEl = priceRoot.querySelector('small.unit-price');
        var unitClone = unitEl ? unitEl.cloneNode(true) : null;

        priceRoot.classList.add('price--shopify-ht-only');

        var orig = item.original_line_price;
        var fin = item.final_line_price;
        var html;

        if (orig !== fin) {
          html =
            '<del><span class="amount">' +
            moneyCents(orig) +
            '</span></del><ins><span class="amount">' +
            moneyCents(fin) +
            '</span></ins>';
        } else {
          html =
            '<ins><span class="amount"><span class="pn-total-line-item" data-id="' +
            escapeAttr(item.key) +
            '"><span class="cart-price-amount--shopify-ht">' +
            moneyCents(fin) +
            ' ' +
            label +
            '</span></span></span></ins>';
        }

        priceRoot.innerHTML = html;
        if (unitClone) {
          priceRoot.appendChild(unitClone);
        }
      });
    });

    document.querySelectorAll('.cart__subtotal-price').forEach(function (el) {
      el.classList.add('cart__subtotal-price--shopify-ht-only');
      el.innerHTML =
        '<span class="cart-price-amount--shopify-ht">' +
        moneyCents(cartState.total_price) +
        ' ' +
        label +
        '</span>';
    });
  };
})();
